import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { Nucc } from '../../../../../../lib/Codes/index.js'
import http from '../../../../../../lib/http'
import { mapTeamMember, unmapTeamMember } from '../../../../../../lib/Proxy/MedicalTeamMember.js'
import * as Card from '../../../../../shared/card'
import CrudTable from '../../../../../shared/CrudTable/index.jsx'
import ConfirmationDeleteDialog from '../../../../../shared/DeleteDialog/ConfirmationDeleteDialog.jsx'
import { Checkbox } from '../../../../../shared/NarusMaterial'
import FormattedPhone from '../../../../../shared/Phone/FormattedPhone.jsx'
import { compartmentReceive } from '../../../../patientActions.js'

import MedicalTeamForm from './form.jsx'

export const mkSpec = patientId => ({
  type: 'medicalTeamMember',
  form: MedicalTeamForm,
  urls: {
    get: () => `/patients/${patientId}/careNetwork`,
    create: () => `/patients/${patientId}/careNetwork`,
    update: entry => `/patients/${patientId}/careNetwork/${entry.id}`,
    delete: entry => `/patients/${patientId}/careNetwork/${entry.id}`
  },
  mapFns: {
    toForm: unmapTeamMember,
    toFhir: entry => {
      entry.emails = _.compact(entry.emails)
      entry.faxes = _.compact(entry.faxes)
      entry.phones = _.compact(entry.phones)
      return mapTeamMember(patientId, entry)
    }
  },
  table: [
    {
      title: 'Last Name',
      displayFn: x => x.lastName
    },
    {
      title: 'First Name',
      displayFn: x => x.firstName
    },
    {
      title: 'Specialty',
      displayFn: x => {
        if (!x.specialty || x.specialty.length !== 10) {
          return null /* 'Unknown / Unspecified'; */
        }

        return _.filter(Nucc, n => n.code === x.specialty)[0].label
      }
    },
    {
      title: '',
      displayFn: () => <span>&nbsp;</span>
    },
    {
      title: 'Phone',
      displayFn: x => (
          <FormattedPhone number={x?.phones?.[0]?.number}/>
      )
    },
    {
      title: '',
      displayFn: () => <span>&nbsp;</span>
    },
    {
      title: 'Email',
        displayFn: x => x?.emails?.[0]?.address
    },
    {
      title: 'Authorization',
      displayFn: ({ authorization }) =>
        authorization && <i className='fa fa-check' />,
      sortFn: x => (x.authorization ? 1 : 0)
    }
  ]
})

class MedicalTeamGrid extends React.Component {
  constructor (props) {
    super(props)
    this.state = { open: true }
    this.handleNoPCP = this.handleNoPCP.bind(this)
  }

  UNSAFE_componentWillMount () {
    const { patientId } = this.props
    this.setState({ noPCPLoading: true })
    http.getRequest(`/patients/${patientId}/careNetwork/noPCP`).then(r => {
      this.setState({
        noPCP: r.noPCP,
        noPCPLoading: false
      })
    })
  }

  handleNoPCP (val) {
    const { patientId } = this.props
    this.setState({ noPCPLoading: true })
    http
      .putRequest(`/patients/${patientId}/careNetwork/noPCP`, {
        noPCP: val
      })
      .then(() => {
        this.setState({
          noPCP: val,
          noPCPLoading: false
        })
      })
  }

  render () {
    const { params, patientId: propPatientId, anyPCP, dispatch } = this.props
    const { noPCP, noPCPLoading } = this.state
    const patientId = params ? params.id : propPatientId
    const spec = mkSpec(patientId)

    return (
      <Card.Card expandable>
        <Card.Header>
          <h2>Medical Team</h2>
          <Checkbox
            label='Patient does not have a PCP'
            value={this.state && noPCP}
            disabled={anyPCP || noPCPLoading}
            onChange={val => {
              this.handleNoPCP(val)
            }}
          />
        </Card.Header>

        <Card.ExpandableWrapper
          style={{ padding: '0 1rem 1rem 1rem' }}
        >
          <CrudTable
            labelButton='Medical Team Member'
            labelNoEntries='Medical Team Members'
            urlFns={spec.urls}
            entryType={spec.type}
            entrySet={patientId}
            tableDefinition={spec.table}
            mapFns={spec.mapFns}
            form={spec.form}
            additionalFormProps={{ noPCP: this.state && noPCP }}
            deleteDialog={ConfirmationDeleteDialog}
            callbackFn={() => {
              dispatch(compartmentReceive(patientId))
              this.props.onSubmit?.()
            }}
            updateKey={this.props.formKey}
          />
        </Card.ExpandableWrapper>
      </Card.Card>
    )
  }
}

MedicalTeamGrid.contextTypes = {
  dispatch: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => ({
  practitionerId: redux.auth.profile.sub,
  patientId: redux.globalVars.params.id,
  anyPCP:
      redux?.crudTable?.medicalTeamMembers?.entries ?? [].filter(
      p => !!p.pcp
    ).length > 0
})

export default connect(mapStateToProps)(MedicalTeamGrid)
